import React from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { Home } from './pages/Home'
import { ProductBuilding } from './pages/ProductBuilding'
import { Consulting } from './pages/Consulting'
import { Training } from './pages/Training'
import { Contact } from './pages/Contact'
import { Blog } from './pages/Blog'
import { BlogPost } from './pages/BlogPost'
import { ScrollToTop } from './components/ScrollToTop'

export function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/product-building" element={<ProductBuilding />} />
        <Route path="/consulting" element={<Consulting />} />
        <Route path="/training" element={<Training />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:id/:slug?" element={<BlogPost />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
    </BrowserRouter>
  )
}